import { createContext } from "react";

export const GalleryContext = createContext({});
